<template>
	<div class="bg-white px-3 goods_create" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 90vh;">
		<router-link :to="{name:'ccgl_ddcl_ccdd'}" style="position: absolute;top: 32px;left: 200px;">
			<el-button size="mini">回到出仓订单</el-button>
		</router-link>
		<el-form ref="form" label-width="80px" style="margin-left: 20px;">
			<div class="d-flex pt-a">
				<div style="width: 50%;">
					<el-form-item label="客户状态">
						<div style="color: #ff0000;" v-if="lists.sfsd == 1">{{lists.js_time}}前不能出货</div>
						<div style="color: #0091ff;" v-else>允许出货</div>
					</el-form-item>
				</div>
				<div style="width: 50%;">
					<el-form-item label="编号">
						<div style="color: #0091ff;">{{this.lists.bh}}</div>
					</el-form-item>
				</div>
			</div>
			<div class="d-flex ">
				<div style="width: 25%;">
					<el-form-item label="客户名称">
						<el-select v-model="lists.kh_id" filterable style="width: 90%;" size="mini" @change="curr" :disabled="lists.id != 0 ? true : false">
						    <el-option v-for="item in khlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="客户简称">
						<el-select v-model="lists.kh_id" filterable style="width: 90%;" size="mini" @change="curr" :disabled="lists.id != 0 ? true : false">
						    <el-option v-for="item in khlist" :key="item.id" :label="item.j_name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="出仓账号">
						<div style="color: #0091ff;">{{user.name}}</div>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="日期">
						<el-date-picker v-model="lists.ddrq" align="right" type="date" size="mini" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 90%;" :picker-options="pickerOptions">
						</el-date-picker>
					</el-form-item>
				</div>
			</div>
			<div class="d-flex">
				<div style="width: 25%;">
					<el-form-item label="货运方式">
						<el-select v-model="lists.thlx" filterable style="width: 90%;" size="mini">
						    <el-option v-for="item in hyfslist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="仓库">
						<el-select v-model="lists.ck_id" filterable style="width: 90%;" size="mini">
						    <el-option v-for="item in cklist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="送货时间" v-if="lists.thlx == 2">
						<el-date-picker v-model="lists.shsj" type="datetime" placeholder="选择日期时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" size="mini" style="width: 95%;">
						</el-date-picker>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="备注">
						<el-input v-model="lists.desc" style="width: 95%;" type="textarea" :rows="2"></el-input>
					</el-form-item>
				</div>
			</div>
			<div class="d-flex" v-if="lists.thlx == 4">
				<div style="width: 25%;">
					<el-form-item label="是否专车">
						<el-radio-group v-model="lists.thlx_sl_zc" size="mini" @change="yfjs">
							<el-radio-button label="0">否</el-radio-button>
							<el-radio-button label="1">是</el-radio-button>
						</el-radio-group>
					</el-form-item>
				</div>
			</div>
			<div v-if="lists.thlx == 13" style="margin-bottom: 20px;">
				<!-- <div style="color: #676767;font-size: 13px;margin-top: 10px;">请填写以下货运站信息</div>
				<div class="d-flex">
					<div style="width: 33%;">
						<el-form-item label="货运站">
							<el-select v-model="lists.hyz_id" filterable style="width: 90%;" size="mini">
							    <el-option v-for="item in hyzlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</div>
					<div style="width: 33%;">
						<el-form-item label="手机">
							<el-input placeholder="请输手机号码" v-model="lists.hyz_dh" clearable size="mini" style="width: 96%;"></el-input>
						</el-form-item>
					</div>
					<div style="width: 33%;">
						<el-form-item label="车牌/地址">
							<el-input placeholder="请输车牌或地址" v-model="lists.hyz_dz" clearable size="mini" style="width: 96%;"></el-input>
						</el-form-item>
					</div>
				</div> -->
				<div style="color: #676767;font-size: 13px;margin-top: 10px;">请填写以下收货人信息</div>
				<div class="d-flex">
					<div style="width: 33%;">
						<el-form-item label="收货人">
							<el-input placeholder="请输收货人姓名" v-model="lists.shr_xm" clearable size="mini" style="width: 96%;"></el-input>
						</el-form-item>
					</div>
					<div style="width: 33%;">
						<el-form-item label="手机">
							<el-input placeholder="请输手机号码" v-model="lists.shr_dh" clearable size="mini" style="width: 96%;"></el-input>
						</el-form-item>
					</div>
					<div style="width: 33%;">
						<el-form-item label="收货地址">
							<el-input placeholder="请输收货地址" v-model="lists.shr_dz" clearable size="mini" style="width: 96%;"></el-input>
						</el-form-item>
					</div>
				</div>
			</div>
			<div style="width: 100%;display: flex;margin-bottom: 10px;">
				<div style="border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0  10px -6px;width: 98%;">
					<div class="m-4 d-flex">
						<div>货物信息</div>
					</div>
					<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);"></div>
					<div class="m-4">
						<el-table :data="ccddhw" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }" >
							<el-table-column align="center" width="65" fixed="left">
								<template slot="header" slot-scope="scope">
									<el-button type="primary" size="mini" icon="el-icon-plus" @click="pustyl"></el-button>
								</template>
								<template slot-scope="scope">
									<el-button type="danger" size="mini" icon="el-icon-delete" @click="pustyldel(scope.$index)"></el-button>
								</template>
							</el-table-column>
              <el-table-column prop="bh" label="货物编码" width="120" fixed="left"></el-table-column>
							<el-table-column prop="hwmc" label="货物名称" width="70"></el-table-column>
              <el-table-column label="包装叫法" width="80" prop="bzjf"></el-table-column>
							<el-table-column label="客户叫法" width="86" prop="kc"></el-table-column>
              <el-table-column label="包装" align="center" width="86" prop="hwbz"></el-table-column>
              <el-table-column label="出仓数量" width="80" align="center">
                <template slot-scope="scope">
                  <div><i v-if="scope.row.js != scope.row.js_temp" style="font-size: 20px" class="el-icon-warning text-danger" title="当前数值与件数值不一致，请确认件数值"></i>{{scope.row.js}}</div>
                </template>
              </el-table-column>

              <el-table-column label="件数" align="center" width="120">
                <template slot-scope="scope">
                  <el-input-number size="mini" v-model="scope.row.js_temp" style="width: 98%;" :min='0' :max='scope.row.kcjs' @blur="handjsChange(scope.$index)"></el-input-number>
                </template>
              </el-table-column>
<!--
							<el-table-column prop="bh" label="条码" width="120" align="center"></el-table-column>
							<el-table-column prop="zmj" label="总面积(平方)" align="center" width="100"></el-table-column>
							<el-table-column prop="ztj" label="总体积(立方)" align="center" width="100"></el-table-column>
							<el-table-column prop="zzl" label="总重量(kg)" align="center" width="90"></el-table-column>
							<el-table-column label="单件重量(kg)" align="center" width="100" prop="djzl"></el-table-column>
							<el-table-column label="单件面积" align="center" width="80" prop="djmj"></el-table-column>
							<el-table-column label="单件体积" align="center" width="80" prop="djtj"></el-table-column>
							<el-table-column label="件数" align="center" width="120">
								<template slot-scope="scope">
									<el-input-number size="mini" v-model="scope.row.js" style="width: 98%;" :min='0' :max='scope.row.kcjs' @change="handjstj(scope.$index,scope.row.js,scope.row.djzl,scope.row.djmj,scope.row.djtj)"></el-input-number>
								</template>
							</el-table-column>
							<el-table-column label="分配数" align="center" >
								<template slot-scope="scope">
									<div v-if="scope.row.fp_js < scope.row.js">{{scope.row.fp_js}}</div>
									<div v-else-if="scope.row.fp_js == scope.row.js" style="color: #0091ff;">{{scope.row.fp_js}}</div>
									<div v-else style="color: #ff0004;">{{scope.row.fp_js}}</div>
								</template>
							</el-table-column>-->
						</el-table>
					</div>
				</div>
			</div>
			<div style="width: 100%;display: flex;margin-bottom: 180px;">
				<div style="border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0  10px -6px;width: 98%;">
					<div class="m-4 d-flex">
						<div>出货仓位</div>
					</div>
					<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);"></div>
					<div class="m-4">
						<el-table :data="ccddhwls" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }" >
							<el-table-column align="center" width="65" fixed="left">
								<template slot="header" slot-scope="scope">
									<el-button type="primary" size="mini" icon="el-icon-plus" @click="pustylls"></el-button>
								</template>
								<template slot-scope="scope">
									<el-button type="danger" size="mini" icon="el-icon-delete" @click="pustyldels(scope.$index)"></el-button>
								</template>
							</el-table-column>
							<el-table-column prop="name" label="货名" width="120" fixed="left"></el-table-column>
							<el-table-column prop="bh" label="条码" align="center"></el-table-column>
							<el-table-column label="货物坐标" align="center">
								<template slot-scope="scope">
									<div>{{scope.row.wz}}</div>
								</template>
							</el-table-column>
							<el-table-column prop="" label="库存数量"align="center">
								<template slot-scope="scope">
									<div>{{scope.row.kcjs}}</div>
								</template>
							</el-table-column>
							<el-table-column label="件数" width="180"  align="center">
								<template slot-scope="scope">
									<el-input-number size="mini" v-model="scope.row.js" style="width: 98%;" :min='0' :max='scope.row.kcjs' @change="handjstjls(scope.$index,scope.row)"></el-input-number>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</el-form>
		<el-dialog title="选择库存" :visible.sync="createModel" top="5vh" customClass="customWidth" width="80%">
			<button-search class="" placeholder="货物名称" @search="searchEvent">
				<template #form>
					<el-form inline ref="form" :model="search" label-width="80px">
						<!-- 搜索内容 -->
						<el-form-item label="货物编号" class="mb-0">
							<el-input v-model="search.bh" size="mini" placeholder="货物编号"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="info" size="mini" @click="searchEvent">搜索</el-button>
							<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
						</el-form-item>
					</el-form>
				</template>
			</button-search>
			<div style="width: 100%;" class="d-flex">
				<el-table ref="multipleTable" :data="ckcplist" tooltip-effect="dark" height="420" size="mini" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="序号" type="index" width="50"></el-table-column>
					<el-table-column prop="bh" label="货物编号" width="120"></el-table-column>
					<el-table-column prop="hwmc" label="货物名称" width="80"></el-table-column>
          <el-table-column prop="bzjf" label="包装叫法" width="120"></el-table-column>
					<el-table-column prop="kc" label="客户叫法" width="120"></el-table-column>
          <el-table-column prop="js" label="库存数量" align="center"></el-table-column>
          <el-table-column prop="mj" label="库存面积" align="center"></el-table-column>
          <el-table-column prop="tj" label="库存体积m³" align="center"></el-table-column>
          <el-table-column prop="zl" label="库存重量kg" align="center"></el-table-column>
					<el-table-column prop="hwmc" label="货物包装" width="100">
						<template slot-scope="scope">
							{{scope.row.hwbzlx == null ? '' : scope.row.hwbzlx.name}}
						</template>
					</el-table-column>

					<el-table-column prop="sl" label="计费数量" align="center"></el-table-column>

					<el-table-column prop="bsl" label="总板数" align="center"></el-table-column>


				</el-table>
			</div>
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="1" :page-sizes="page.sizes" :page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper" :total="page.total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange"></el-pagination>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submits(multipleSelection)">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="选择货物" :visible.sync="createModells" top="5vh" customClass="customWidth" width="80%">
			<div style="width: 100%;" class="d-flex">
				<el-table ref="multipleTable" :data="kchwls" tooltip-effect="dark" height="420" size="mini" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="bh" label="编号" width="120"></el-table-column>
					<el-table-column prop="name" label="货物名称" width="80"></el-table-column>
					<el-table-column label="货物坐标">
						<template slot-scope="scope">
							{{scope.row.cczb.wz}}
						</template>
					</el-table-column>
					<el-table-column prop="js" label="总件数" width="80" align="center"></el-table-column>
					<el-table-column prop="mj" label="总面积" width="80" align="center"></el-table-column>
					<el-table-column prop="tj" label="总体积" width="80" align="center"></el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModells = false">取 消</el-button>
				<el-button type="primary" @click="submitsls(multipleSelection)">确 定</el-button>
			</div>
		</el-dialog>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;z-index: 100;width: 100%;margin-left: -20px;">
			<div style="width: 140px;margin-left: 30px;">经办人：<span style="color: #0091ff;">{{lists.cjrdata.name}}</span></div>
			<div style="width: 90px;">共<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{lists.hwxm}}</span>项</div>
			<div style="width: 140px;">
				出仓件数：<span style="color: #0091ff;margin-left: 8px;margin-right: 10px;">{{ccjs}}</span>
			</div>
			<div style="width: 170px;">
				出仓重量：<span style="color: #0091ff;margin-left: 8px;margin-right: 10px;">{{cczl}}吨</span>
			</div>
			<div style="width: 170px;">
				出仓面积：<span style="color: #0091ff;margin-left: 8px;margin-right: 10px;">{{ccmj}}m²</span>
			</div>
			<div style="width: 170px;">
				出仓体积：<span style="color: #0091ff;margin-left: 8px;margin-right: 10px;">{{cctj}}m³</span>
			</div>
			<div style="width: 130px;">
				运费：<span style="color: #0091ff;margin-left: 8px;margin-right: 10px;">{{zyf}}</span>元
			</div>
			<el-button type="primary" @click="submit" style="margin-left: 5%;">提交</el-button>
		</el-footer>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import buttonSearch from '@/components/common/button-search.vue';
	import common from '@/common/mixins/common.js';
	export default {
		mixins: [common],
		inject: ['app', 'layout'],
		components: {
			buttonSearch
		},
		data() {
			return {
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
					shortcuts: [{
						text: '今天',
						onClick(picker) {
							picker.$emit('pick', new Date());
						}
					}]
				},
				ccjs:0,
				ccmj:0,
				cctj:0,
				cczl:0,
				zyf:0,
				lists: {
				},
				ywylist:[],
				khlist:[],
				cklist:[],
				ckcplist:[],
				bmlist:[],
				valuea: false,
				createModel: false,
				createModells: false,
				preUrl: 'khkc',
				multipleSelection:[],
				ccddhw:[],
				ccddhwls:[],
				kchwls:[],
				tableDatab:[],

				hwlxlist:[],
				hyfslist:[],
				jfdwlist:[],
				jfbzlist:[],
				hwbzlist:[],
				hyzlist:[],
				jfzqlist: [{
					id: 1,
					name: '1天'
				}, {
					id: 3,
					name: '3天'
				}, {
					id: 7,
					name: '7天'
				}, {
					id: 10,
					name: '10天'
				}],
				ddsxlist: [{
					id: 0,
					name: '散货'
				}, {
					id: 1,
					name: '大货'
				}],
				jfmslist: [{
					id: 0,
					name: '重量'
				}, {
					id: 1,
					name: '体积'
				}],
				flfylxlist: [],
				search: {
					keyword: "",
					bh:''
				},
				bantj:1.68 ,//每板体积
				dqkhxx:{} // 当前客户信息
			}
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			}),



		},
		created() {
			this.lists = this.$route.params.data;
			console.log(this.lists)
			this.dqkhxx = this.lists.khdata
			this.ccmj = this.lists.ccmj
			this.ccjs = this.lists.ccjs
			this.cctj = this.lists.cctj
			this.cczl = this.lists.cczl
			this.zyf = this.lists.zyf
			if(this.lists.hwxm != 0){
				this.ccddhw = this.lists.ccddhw
        this.ccddhw.forEach((item,index)=>{
          this.ccddhw[index].js_temp = this.ccddhw[index].kcjs
        })
				this.ccddhwls = this.lists.ccddhwls
			}

			this.axios.get('/admin/flflx/1', { token: true }).then(res => {
				this.flfylxlist = res.data.data.list;
			});
			this.axios.get('/admin/hyxl/1', { token: true }).then(res => {
				this.hyzlist = res.data.data.list;
			});
			this.axios.get('/admin/thlx/1', { token: true }).then(res => {
				this.hyfslist = res.data.data.list;
			});


			this.axios.get('/admin/cangkus', { token: true }).then(res => {
				this.cklist = res.data.data;
			});

			this.axios.get('/admin/hwlx/1', { token: true }).then(res => {
				this.hwlxlist = res.data.data.list;
			});


			this.axios.get('/admin/jfbz/1', { token: true }).then(res => {
				this.jfbzlist = res.data.data.list;
			});

			this.axios.get('/admin/hwbz/1', { token: true }).then(res => {
				this.hwbzlist = res.data.data.list;
			});
			this.axios.get('/admin/khxxsrcdd', { token: true }).then(res => {
				this.khlist = res.data.data;
			});
		},
		methods: {
			curr(val){
				let data = this.khlist.filter(item=>{
					return item.id == val
				})
				this.dqkhxx = data[0]
				this.lists.sfsd = data[0].sfsd
				this.lists.js_time = data[0].js_time
				this.lists.thlx = data[0].hyfs
				let datas = this.jfdwlist.filter(item=>{
					return item.id == data[0].jfdw_id
				})
				this.lists.hyz_id = data[0].xl_id
			},

			pustyl() {
				if(!this.lists.kh_id){
					this.$message({
						type: "warning",
						message: "请先选择客户"
					})
				}else{
					this.getList()
					this.createModel = true;
				}
			},
			pustylls() {
				if(!this.lists.kh_id){
					this.$message({
						type: "warning",
						message: "请先选择客户"
					})
				}else{

					if(this.lists.ccddhw.length == 0){
						let x = this.ccddhw.map(item=>{
							return item.bh
						})
						this.getls(x)
						this.createModells = true;
					}else{
						let x = this.lists.ccddhw.map(item=>{
							return item.bh
						})

						this.getls(x)
						this.createModells = true;
					}

				}
			},
			pustyldel(e) {
				this.ccddhw.splice(e,1)
			},
			pustyldels(e) {
				this.ccddhwls.splice(e,1)
			},
			submits(e) {
        if (e.length === 0) {
          this.$message({
            message: `请选择数据`,
            type: 'warning',
          });
          return
        }

        let ok = true;
        this.ccddhw.forEach((item,index)=>{
              for(let i of e){
                if(item.bh === i.bh){
                  setTimeout(()=>{
                    this.$message({
                      message: `不可重复添加，编号(${i.bh})已经存在`,
                      type: 'error'
                    });
                  },0)
                  ok = false
                }
              }
        })
        if (!ok) return
				for(let i of e){
					let data = {
						kc_id:i.id,
						bh:i.bh,
						kh_id:i.kh_id,
						hwmc:i.hwmc,
						bzjf:i.bzjf,
						hwbz:i.hwbzlx?.name||"未知",
						bsl:i.bsl,
						kcjs:i.js,
						kc:i.kc,
						djmj:i.djmj,
						djtj:i.djtj,
						djzl:i.djzl,
						js:0,
						js_temp:i.js,
					}
					this.ccddhw.push(data)
				}
				this.lists.hwxm = this.ccddhw.length
				this.createModel = false;
			},
			submitsls(e) {
				if(this.ccddhwls.length == 0){
					this.ccddhwls = e.map(i=>{
						return {
							kczb_id:i.kcmx_id,
							zb:i.zb,
							bh:i.bh,
							kcjs:i.js,
							js:0,
							ccdd_id:this.lists.id,
							name:i.name,
							cd:i.cd,
							kd:i.kd,
							gd:i.gd,
							mjzl:i.mjzl,
							mjmj:i.mjmj,
							mjtj:i.mjtj,
							ck:i.ck,
							ck_k:i.ck_k,
							ck_q:i.ck_q,
							ck_h:i.ck_h,
							ck_l:i.ck_l,
							sl:i.sl,
							mj:0,
							tj:0,
							ds:0,
							wz:i.cczb.wz
						}
					})
				}else{
					for(let i of e){
						let list = {
							kczb_id:i.kcmx_id,
							zb:i.zb,
							bh:i.bh,
							kcjs:i.js,
							js:0,
							ccdd_id:this.lists.id,
							name:i.name,
							cd:i.cd,
							kd:i.kd,
							gd:i.gd,
							mjzl:i.mjzl,
							mjmj:i.mjmj,
							mjtj:i.mjtj,
							ck:i.ck,
							ck_k:i.ck_k,
							ck_q:i.ck_q,
							ck_h:i.ck_h,
							ck_l:i.ck_l,
							sl:i.sl,
							mj:0,
							tj:0,
							ds:0,
							wz:i.cczb.wz
						}
						this.ccddhwls.push(list)
					}
				}

				this.createModells = false;
			},
			getls(x){
				this.axios.post('/admin/ccdd_khkc', x, {
					token: true
				}).then(res => {
					this.kchwls = res.data.data
				})
			},
			getListUrl() {
				return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&keyword=${this.search.keyword}&bh=${this.search.bh}&kh_id=${this.lists.kh_id}&ck_id=${this.lists.ck_id}`
			},
			getListResult(e) {
				this.ckcplist = e.list;
      },
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},

			handleChange(lx,e,index) {
				if(lx == 'sl'){
					this.ccddhw[index].hj = this.ccddhw[index].dj * this.ccddhw[index].sl
				}else if(lx == 'dj'){
					this.ccddhw[index].hj = this.ccddhw[index].dj * this.ccddhw[index].sl
				}else{
					this.ccddhw[index].dj = this.ccddhw[index].hj / this.ccddhw[index].sl
				}
				this.lists.spze = 0
				for(let i of this.ccddhw){
					this.lists.spze += i.hj
				}
				this.lists.ddje = this.lists.spze * (this.lists.sl/100) + this.lists.spze
			},
			handleChanges(e){
				this.lists.ddje = this.lists.spze * (e/100) + this.lists.spze
			},
			handjsChange(index){
        this.ccddhw[index].js = this.ccddhw[index].js_temp
        let row = this.ccddhw[index]
        this.handjstj(index,row.js,row.djzl,row.djmj,row.djtj)
			},
			handjstj(index,js,zl,mj,tj){
				this.ccddhw[index].zzl = (js * parseFloat(zl)/1000).toFixed(2) // 重量（吨）
				this.ccddhw[index].zmj = (js * parseFloat(mj)).toFixed(2) // 面积
				this.ccddhw[index].ztj = (js * parseFloat(tj)).toFixed(2) // 体积
				this.yfjs()
			},
			handjstjls(index,data){
				let result = {}
				if(this.dqkhxx.jfdw_id == 1){
					this.ccddhwls[index].sl = this.ccddhwls[index].ds
				}else if(this.dqkhxx.jfdw_id == 2){
					this.ccddhwls[index].sl = this.ccddhwls[index].mj
				}else if(this.dqkhxx.jfdw_id == 3){
					let bzdsl = Math.floor(this.bantj / parseFloat(this.ccddhwls[index].mjtj))
					let bsl = Math.ceil(data.js / bzdsl).toFixed(2)
					this.ccddhwls[index].sl = bsl
				}else if(this.dqkhxx.jfdw_id == 4){
					this.ccddhwls[index].sl = data.js
				}
				let arr = this.ccddhwls.map(item=>{
					return {
						bh:item.bh,
						js:item.js
					}
				})
				arr.forEach(obj => {
				    // 判断结果对象中是否已存在该属性名称
				    if (result[obj.bh]) {
				        // 若已存在则将当前对象的value与之前的value相加并更新到结果对象中
				        result[obj.bh] += obj.js;
				    } else {
				        // 若不存在则直接赋值给结果对象
				        result[obj.bh] = obj.js;
				    }
				});
				for(let e of Object.entries(result)){
					let num = 0
					for(let i of this.ccddhw){
						if(i.bh == e[0]){
							this.ccddhw[num].fp_js = e[1]
						}
						num += 1
					}
				}
			},
			yfjs(){
				this.lists.ccddhw = this.ccddhw
				let ccjs = 0
				let cczl = 0
				let ccmj = 0
				let cctj = 0
				for(let i of this.ccddhw){
					ccjs += parseFloat(i.js)
					cczl += parseFloat(i.zzl)
					cctj += parseFloat(i.ztj)
					ccmj += parseFloat(i.zmj)
				}
				this.ccjs = ccjs
				this.ccmj = ccmj.toFixed(2)
				this.cctj = cctj.toFixed(2)
				this.cczl = cczl.toFixed(2)

				this.lists.ccjs = this.ccjs
				this.lists.ccmj = this.ccmj
				this.lists.cctj = this.cctj
				this.lists.cczl = this.cczl

				// 运费
				let yufei = 0
				if(this.lists.thlx == 2){ // 班车
					if(this.dqkhxx.hyfs_bcdw == 1){ // 单位：件
						yufei = parseFloat(this.dqkhxx.hyfs_dj) * ccjs
						if(yufei < 3){
							// 保底3元
							yufei = 3
						}else if(yufei >= 80 && yufei < 160){
							// 满80元打9折
							yufei = Math.round(yufei * (9 / 10))
						}else if(yufei >= 160 && yufei < 240){
							// 满160元打8折
							yufei = Math.round(yufei * (8 / 10))
						}else{
							// 满240元打7.5折
							yufei = Math.round(yufei * (7.5 / 10))
						}
					}else{ // 单位：吨
						yufei = 80 * cczl
						if(yufei < 3){
							// 保底3元
							yufei = 3
						}else if(yufei >= 80 && yufei < 160){
							// 满80元打9折
							yufei = Math.round(yufei * (9 / 10))
						}else if(yufei >= 160 && yufei < 240){
							// 满160元打8折
							yufei = Math.round(yufei * (8 / 10))
						}else{
							// 满240元打7.5折
							yufei = Math.round(yufei * (7.5 / 10))
						}
					}
					this.lists.zyf = yufei
				}else if(this.lists.thlx == 1){ // 自提 默认运费为0
					this.lists.zyf = yufei
				}else if(this.lists.thlx == 3){ // 黄沙
					let newhwds = cczl * 1000
					if(newhwds <= 200){ // 200公斤内 30元
						yufei = 30
					}else if(newhwds > 201 && newhwds <= 300){ // 201公斤-300公斤 40元
						yufei = 40
					}else if(newhwds > 301 && newhwds <= 400){ // 301公斤-400公斤 50元
						yufei = 50
					}else if(newhwds > 401 && newhwds <= 500){ // 401公斤-500公斤 60元
						yufei = 60
					}else if(newhwds > 501 && newhwds <= 1000){ // 501公斤-1000公斤 70元
						yufei = 70
					}else if(newhwds > 1001 && newhwds <= 1200){ // 1001公斤-1200公斤 80元
						yufei = 80
					}else if(newhwds > 1201 && newhwds <= 1400){ // 1201公斤-1400公斤 100元
						yufei = 100
					}else if(newhwds > 1401 && newhwds <= 1600){ // 1401公斤-1600公斤 110元
						yufei = 110
					}else if(newhwds > 1601 && newhwds <= 1800){ // 1601公斤-1800公斤 130元
						yufei = 130
					}else if(newhwds > 1801 && newhwds <= 2000){ // 1801公斤-2000公斤 140元
						yufei = 140
					}else if(newhwds > 2001 && newhwds <= 4000){ // 2001公斤-4000公斤 160元
						yufei = 160
					}
					this.lists.zyf = yufei
				}else if(this.lists.thlx == 4){ // 省冷
					if(this.lists.thlx_sl_zc == 1){ // 专车 (待补充)
						yufei = 200
						this.lists.zyf = yufei
					}else{ // 非专车
						let newtj = ((cczl * 1000) / cctj) * 2 // 平均每2立方的重量kg
						if(newtj < 700){ // 2立方体积重量为700Kg（不含）以下的，60元/吨
							yufei = Math.round(cczl * 60)
						}else{
							yufei = Math.round(cczl * 40)
						}
						if(yufei < 50){
							yufei = 50
						}
					}
					// 运费时间-优惠
					var now = new Date();
					var hour = now.getHours();
					if(hour >=12 && hour < 18){
						this.lists.zyf = Math.round(yufei * (8.5 / 10))
					}else{
						this.lists.zyf = Math.round(yufei * (9 / 10))
					}
					this.lists.zyf = yufei
				}
				this.zyf = this.lists.zyf

			},
			// 搜索事件
			searchEvent(e = false) {
				// 简单搜索
				if (typeof e === 'string') {
					this.search.keyword = e
					this.getList()
					return
				}
				// 高级搜索
				this.getList()
			},
			// 清空筛选条件
			clearSearch() {
				this.search = {
					keyword: "",
					bh: '',
				}
			},
			//提交
			submit() {
				if(this.lists.sfsd == 1){
					this.$message({
						type: "error",
						message: "客户出仓被锁定"
					})
				}else{
					this.lists.ccjs = this.ccjs
					this.lists.ccmj = this.ccmj
					this.lists.cctj = this.cctj
					this.lists.cczl = this.cczl
					if(this.lists.hwxm != 0){
						this.lists.ccddhw = this.ccddhw
					}
					if(this.ccddhwls.length != 0){
						this.lists.ccddhwls = this.ccddhwls
					}
					let x = this.lists
					this.layout.showLoading()
					let url = this.lists.id === 0 ? '/admin/ccdd' : '/admin/ccdd/' + this.lists.id

					this.axios.post(url, x, {
						token: true
					}).then(res => {
						console.log(res);
						this.$message({
							type: "success",
							message: this.lists.id === 0 ? "下单成功" : "修改成功"
						})
						this.$router.push({
							name: "ccgl_ddcl_ccdd"
						})
						this.layout.hideLoading()
					}).catch(err => {
						this.layout.hideLoading()
					})
				}

			}
		},
	}
</script>

<style>
	.goods_create .el-form-item {
	    margin-bottom: 4px !important;
	}
	.pt-a{
		padding-top: 20px;
	}
	.el-form-item__label {
		width: 84px !important;
	}
</style>
